import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { GroupDetailDialogComponent } from '../group-detail-dialog/group-detail-dialog.component';
import { ProcessControlService } from 'src/app/services/process-control.service';

interface LogAction {
  datetime: string;
  description: string;
}

interface InvoiceGroup {
  orderIds: number[];
  customerIds: number[];
  sqsMessageId?: string;
  orderNumbers?: string[];
  customerNames?: string[];
  success?: boolean | null;
}

interface InvoiceResultData {
  log: LogAction[];
  totalGroups: number;
  allotment: number;
  groups: InvoiceGroup[];
  totalOrders: number;
  sqsMessageId?: string;
}

@Component({
  selector: 'app-result-dialog-invoice',
  templateUrl: './result-dialog-invoice.component.html',
  styleUrls: ['./result-dialog-invoice.component.scss']
})
export class ResultDialogInvoiceComponent implements OnInit {
  data: InvoiceResultData;
  logActions: LogAction[] = [];
  groups: InvoiceGroup[] = [];
  totalOrders: number = 0;
  totalGroups: number = 0;
  allotment: number = 0;
  loadingStatuses: { [key: number]: boolean } = {};

  constructor(
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private dialog: DialogService,
    private processControlService: ProcessControlService
  ) {
    if (this.config.data) {
      this.data = this.config.data;
      this.logActions = this.data.log || [];
      this.groups = this.data.groups || [];
      this.totalOrders = this.data.totalOrders || 0;
      this.totalGroups = this.data.totalGroups || 0;
      this.allotment = this.data.allotment || 0;
    }
  }

  ngOnInit() {
    // Buscar o status success para cada grupo
    this.loadGroupStatuses();
  }

  loadGroupStatuses() {
    this.groups.forEach((group, index) => {
      if (group.orderIds && group.orderIds.length > 0) {
        const firstOrderId = group.orderIds[0];
        this.loadingStatuses[index] = true;

        this.processControlService.getProcessControlOrderByOrderId(firstOrderId).subscribe({
          next: (response) => {
            if (response) {
              group.success = response.success;
            }
            this.loadingStatuses[index] = false;
          },
          error: (err) => {
            console.error(`Erro ao buscar status do grupo ${index + 1}:`, err);
            this.loadingStatuses[index] = false;
          }
        });
      }
    });
  }

  getSuccessStatus(group: InvoiceGroup, index: number): string {
    if (this.loadingStatuses[index]) {
      return 'loading';
    }
    if (group.success === null || group.success === undefined) {
      return 'unknown';
    }
    return group.success ? 'success' : 'error';
  }

  getSuccessIcon(group: InvoiceGroup, index: number): string {
    const status = this.getSuccessStatus(group, index);
    if (status === 'loading') return 'pi pi-spin pi-spinner';
    if (status === 'success') return 'pi pi-check';
    if (status === 'error') return 'pi pi-times';
    return 'pi pi-question-circle';
  }

  getSuccessLabel(group: InvoiceGroup, index: number): string {
    const status = this.getSuccessStatus(group, index);
    if (status === 'loading') return 'Carregando...';
    if (status === 'success') return 'Sucesso';
    if (status === 'error') return 'Erro';
    return 'Desconhecido';
  }

  formatDateTime(dateTime: string): string {
    if (!dateTime) return '';
    const date = new Date(dateTime);
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  }

  getTimeDifference(index: number): string {
    if (index === 0) return '0.00s';
    const current = new Date(this.logActions[index].datetime);
    const previous = new Date(this.logActions[index - 1].datetime);
    const diff = (current.getTime() - previous.getTime()) / 1000;
    return diff.toFixed(2) + 's';
  }

  getActionIcon(description: string): string {
    if (description.includes('Início')) return 'pi pi-play-circle';
    if (description.includes('Erro') || description.includes('inválida')) return 'pi pi-times-circle';
    if (description.includes('sucesso') || description.includes('concluído')) return 'pi pi-check-circle';
    if (description.includes('AVISO')) return 'pi pi-exclamation-triangle';
    if (description.includes('Grupo')) return 'pi pi-sitemap';
    if (description.includes('Mensagem enviada')) return 'pi pi-send';
    return 'pi pi-info-circle';
  }

  getActionClass(description: string): string {
    if (description.includes('Erro') || description.includes('inválida')) return 'error-action';
    if (description.includes('sucesso') || description.includes('concluído')) return 'success-action';
    if (description.includes('AVISO')) return 'warning-action';
    return 'info-action';
  }

  get showGroupsAsList(): boolean {
    return this.groups.length > 10;
  }

  formatIds(ids: number[] | string[]): string {
    return ids.join(', ');
  }

  openGroupDetail(group: InvoiceGroup) {
    this.dialog.open(GroupDetailDialogComponent, {
      width: '80%',
      height: '85%',
      dismissableMask: false,
      data: { group },
      header: 'Detalhes do Grupo - SQS: ' + (group.sqsMessageId || 'N/A'),
    });
  }
}
